import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@mui/material';
import { RadioButtonUnchecked } from '@mui/icons-material';

import styles from './Slider.module.css';
import type { ConfigState } from 'services/store/features/Config/types';

interface Props {
  config: ConfigState;
}

export default function Slider({
  config,
}: Props) {
  const { t } = useTranslation();

  const [stateSlider, setStateSlider] = useState('salary');

  const handleCheckbox = (value: string) => {
    setStateSlider(value);
  };

  return (
    <div className={styles.sliderContainer}>
      <img className={styles.imageSlider} src={`${process.env.PUBLIC_URL}/images/${stateSlider}.svg`} alt={stateSlider} />
      <div className={styles.buttonSlider}>
        <Checkbox
          className={`${styles.checkboxSlider} ${stateSlider === 'salary' ? styles.checked : ''}`}
          icon={<RadioButtonUnchecked />}
          checkedIcon={<span />}
          name="salary"
          checked={stateSlider === 'salary'}
          onChange={() => handleCheckbox('salary')}
        />
        <Checkbox
          className={`${styles.checkboxSlider} ${stateSlider === 'documents' ? styles.checked : ''}`}
          icon={<RadioButtonUnchecked />}
          checkedIcon={<span />}
          name="documents"
          checked={stateSlider === 'documents'}
          onChange={() => handleCheckbox('documents')}
        />
        <Checkbox
          className={`${styles.checkboxSlider} ${stateSlider === 'bank-check' ? styles.checked : ''}`}
          icon={<RadioButtonUnchecked />}
          checkedIcon={<span />}
          name="bank-check"
          checked={stateSlider === 'bank-check'}
          onChange={() => handleCheckbox('bank-check')}
        />
      </div>
      <p className={styles.headerSlideTitle}>{t(`eligible.header.${stateSlider}.title`)}</p>
      <p className={styles.headerSlideDescription}>
        {t(`eligible.header.${stateSlider}.description`, {
          amount: (
            stateSlider === 'salary' ? Number.parseFloat(config.amountRegistration) : Number.parseFloat(config.amountRegistration) / 2
          ).toLocaleString(undefined, { minimumFractionDigits: 2 }),
        })}
      </p>
    </div>
  );
}
